export default "__VITE_ASSET__ad6c3c67__"